/**
 * @deprecated Use ProductCatalog data not Zidi data.
 */
type GenericAsset = {
  color: string | null | undefined
  kind: string | null | undefined
}

/** Gallery images in our data are defined as those images where the "kind" matches the "color" */
/**
 * @deprecated Use ProductCatalog data not Zidi data.
 */
export function getProductGalleryImages<T extends GenericAsset>(images: T[]): T[] {
  return images.filter(
    image => image.color && image.kind && image.color.toLowerCase() === image.kind.toLowerCase()
  )
}
